module.exports = __webpack_public_path__ + "img/bookSteps.5afe976e.png";